// reload alle 2 Minuten
setTimeout(function () {
    window.location.reload();
}, 120000);